/*
 * @Author: Ximen
 * @Date: 2021-03-17 15:16:02
 * @LastEditors: Ximen
 * @LastEditTime: 2021-04-02 15:53:47
 */
import { createApp } from 'vue';
import Antd from 'ant-design-vue';
import App from '@/App.vue';
import router from './router/index';
import 'ant-design-vue/dist/antd.css';
import './assets/styles/index.stylus';
import './assets/iconfont/iconfont.css';
import store from './store';

const app = createApp(App);

app
  .use(store)
  .use(router)
  .use(Antd)
  .mount('#app');
